"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.webConfigContext = void 0;
const web_experiments_1 = require("@snapchat/web-experiments");
exports.webConfigContext = (0, web_experiments_1.createConfigContext)([web_experiments_1.Namespace.SHARED_WEB_UI]);
//# sourceMappingURL=webConfigContext.js.map